import React from "react";

import "./QRCodeGenerator.css";

import { averyTemplates } from "../../constants";

import GridItem from "./GridItem";

const QRCodeLayout = (props) => {
  const { plants, downloadRef, selectedTemplate } = props;

  const template = averyTemplates[selectedTemplate];

  //console.log(template);

  return (
    //grid
    <div
      className="grid-container"
      ref={downloadRef}
      style={{
        width: template.gridContainerWidth,
        height: template.gridContainerHeight,
        padding: template.gridContainerPadding,

        gridTemplateColumns: template.gridTemplateColumns,

        backgroundColor: "white",
      }}
    >
      {plants.map((plant, index) => {
        return <GridItem key={plant.itemKey || `${plant.plantID || "blank"}-${index}`} plant={plant} template={template} />;
      })}
    </div>
  );
};

export default QRCodeLayout;
